/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { withStore } from 'fierry/react';


const getInitialState = () =>
{
  return { x: 0, y: 0, dnd: false };
};


const move = (state, { dx, dy }) =>
{
  return { ...state, x: state.x + dx, y: state.y + dy };
};


const startDrag = (state) =>
{
  return { ...state, dnd: true };
};


const endDrag = (state) =>
{
  return { ...state, dnd: false };
};


const reset = (state) =>
{
  return { ...state, x: 0, y: 0 };
};


export default withStore(getInitialState, { move, startDrag, endDrag, reset });
